"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imeiRequestApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var imeiRequestApi = exports.imeiRequestApi = {
  checkReceive: function checkReceive(data) {
    return (0, _request.default)({
      url: "/imei-request/check",
      method: "post",
      data: data
    });
  },
  findRequestImeis: function findRequestImeis(params) {
    return (0, _request.default)({
      url: "/imei-request/imeis",
      method: "get",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/imei-request",
      method: "post",
      data: data
    });
  },
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: "/imei-request",
      params: params
    });
  },
  findDetail: function findDetail(id, params) {
    return (0, _request.default)({
      url: "/imei-request/".concat(id, "/detail"),
      params: params
    });
  }
};